'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const MoreVertIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="MoreVertIcon">
      <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 2C0 0.89543 0.89543 0 2 0C3.10457 0 4 0.89543 4 2C4 3.10457 3.10457 4 2 4C0.89543 4 0 3.10457 0 2Z"
          fill="#3D517B"
          fillOpacity="0.56"
        />
        <path
          d="M0 9C0 7.89543 0.89543 7 2 7C3.10457 7 4 7.89543 4 9C4 10.1046 3.10457 11 2 11C0.89543 11 0 10.1046 0 9Z"
          fill="#3D517B"
          fillOpacity="0.56"
        />
        <path
          d="M2 14C0.89543 14 0 14.8954 0 16C0 17.1046 0.89543 18 2 18C3.10457 18 4 17.1046 4 16C4 14.8954 3.10457 14 2 14Z"
          fill="#3D517B"
          fillOpacity="0.56"
        />
      </svg>
    </SvgIcon>
  )
}

MoreVertIcon.propTypes = {
  sx: PropTypes.object
}
